import * as React from 'react';
import classNames from 'classnames';

import './styles.scss';
import { ITagInputProps, TagInput } from '@blueprintjs/core';

export interface IControlTagInputProps extends Omit<ITagInputProps, 'fill' | 'leftIcon' | 'rightElement'> {
    /** Addon element to prepend to field */
    addOnFront?: React.ReactElement;
    /** className to append */
    className?: string;
}

interface IState {
    hasFocus: boolean;
}

/**
 * Tag input component
 */
export default class ControlTagInput extends React.Component<IControlTagInputProps, IState> {
    static displayName: string = 'ControlTagInput';

    constructor (props: IControlTagInputProps) {
        super(props);
        this.state = {
            hasFocus: false,
        };
    }

    render () {
        return (
            <TagInput
                {...this.props}
                leftIcon={this.props.addOnFront && (
                    <span className="control-taginput-addon-front">{this.props.addOnFront}</span>
                )}
                className={classNames('control-taginput', this.props.className)}
            />
        );
    }
}
